import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-md-5 offset-md-1" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "medicare-part-a-effective-date" }, " Medicare Part A Effective Date ", -1 /* HOISTED */)
const _hoisted_4 = { class: "input-group date datepickerInput" }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_DatePicker, { getDate: _ctx.getDate }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              type: "text",
              name: "medicare-part-a-effective-date",
              class: "form-control",
              value: _ctx.formatDateInput(_ctx.payer.MedicarePartAEffectiveDate),
              placeholder: "MM/DD/YYYY",
              autocomplete: "off"
            }, null, 8 /* PROPS */, _hoisted_5),
            _hoisted_6
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["getDate"])
    ])
  ]))
}